export type FormSubmissionSuccess = { trackingId: string };

type FormTrackingOptions = FormSubmissionSuccess & {
	statisticsConsent: boolean;
	marketingConsent: boolean;
	gtmConfigured: boolean;
};

/** Best effort only: analytics must never affect a successful submission. */
export function trackFormSubmission(options: FormTrackingOptions): void {
	try {
		const trackingId = options.trackingId.trim();
		if (!trackingId || !options.gtmConfigured || !options.statisticsConsent || typeof window === 'undefined') return;
		const target = window as Window & { dataLayer?: { push: (event: object) => unknown } };
		// Do not queue submissions when the host has not initialized its data layer.
		target.dataLayer?.push({
			event: 'biz_form_submit_success',
			form_id: trackingId,
			marketing_consent: options.marketingConsent === true,
		});
	} catch {
		// A missing or broken tag integration must not interrupt the form.
	}
}
